import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Horas buscando el "prompt mágico" en TikTok que nunca funciona igual en tu caso', 'Resultados genéricos y aburridos que podrías haber escrito tú mismo en menos tiempo', 'Sin saber cuándo usar ChatGPT y cuándo usar DeepSeek — usás todo para todo', 'Contenido que claramente "parece IA" y nadie quiere leer ni compartir', 'Tareas que siguen tardando horas aunque "uses IA" porque no tenés el flujo correcto', 'Semana tras semana el mismo ciclo — mucho tiempo invertido, pocos resultados concretos'];
  return <section className="py-20 px-4 bg-surface/30" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-190">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-191">
            ¿Cuántas horas más vas a perder así?
          </h2>
          <p className="text-lg text-muted mb-8" data-id="element-192">
            Querés dominar la Inteligencia Artificial. Sabés que el mundo
            cambió. Pero nadie te dijo que ibas a pasar horas escribiendo
            prompts que no funcionan, obteniendo respuestas genéricas que no
            sirven para nada y llegando al final del día con la sensación de que
            la IA "no es para ti".
          </p>
          <div className="inline-block bg-danger/10 border border-danger/20 text-danger font-bold px-6 py-3 rounded-lg text-xl" data-id="element-193">
            No es falta de inteligencia. Es falta de un sistema.
          </div>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-194">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-surface border border-border p-4 rounded-xl" data-id="element-195">
              <XCircle className="text-danger shrink-0 mt-0.5" size={24} data-id="element-196" />
              <p className="text-gray-300 text-lg" data-id="element-197">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-198">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-brand" data-id="element-199">
            ¿Y si esta fuera la última semana que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}